import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { BehaviorSubject, Observable, Observer } from "rxjs";
import { Messages } from "../../../model/messages";
import { Involved } from "../../../model/involved";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { SingleChoice } from "../../../model/singlechoice";
import { Ticket } from "../../../model/ticket";
import { InvolvedService } from "../../../services/involved.service";
import { AuthService } from "../../../auth.service";
import { Router } from "@angular/router";
import { NavigationHelper } from "../../../services/navigation.helper";
import { UsersService } from "../../../services/users.service";
import { Navigation } from "../../../model/navigation";
import { ActionButtonSubmit } from "../../../model/action-button-submit";
import { TicketService } from "../../../services/ticket.service";
import { Labeler } from "../../../model/labeler";

@Component({
    selector: "involved-details",
    templateUrl: "./involved-details.component.html",
    styleUrl: "./involved-details.component.css",
})
export class InvolvedDetailsComponent implements OnInit {
    messages = new BehaviorSubject<Messages>(Messages.EMPTY);
    involved = new BehaviorSubject<Involved>(new Involved(0, 0, ""));
    editMode: boolean = true;
    involvedForm: FormGroup;
    @Input() currentTicket: Observable<Ticket>;
    ticket: Ticket | null = null;
    currentId: number | null;
    completionUrl = new BehaviorSubject<string>("");
    isLoading: boolean = false;
    @Output() formClosed = new EventEmitter<void>();
    showSaveButton: boolean = true;

    constructor(
        private ticketService: TicketService,
        private involvedService: InvolvedService,
        private auth: AuthService,
        private fb: FormBuilder,
        private router: Router,
        private nav: NavigationHelper,
        private users: UsersService
    ) { }

    ngOnInit(): void {
        this.initializeForm();

        const savedState = window.history.state;
        if (savedState && savedState.tempInvolvedId) {
            this.involvedForm.patchValue({ involved: savedState.tempInvolvedId });
        }

        if (this.currentTicket) {
            this.currentTicket.subscribe((ticket) => {
                if (ticket) {
                    this.currentId = ticket.id;
                    this.ticket = ticket;
                    const url = `tickets/${this.currentId}/fragmentedit/involved/${Navigation.NEW}`;
                    this.completionUrl.next(url);
                }
            });
        }
    }
    private initializeForm(): void {
        this.involvedForm = this.fb.group({
            involved: ["", Validators.required],
        });
    }

    saveInvolved(): void {
        if (this.involvedForm.valid) {
            const formValues = this.involvedForm.value;
            const selectedUserId = String(formValues.involved);
            const existing: Involved[] = this.ticket?.parts?.ticketInvolved ?? [];
            const duplicate = existing.some(i => String(i.involved) === selectedUserId);
            if (duplicate) {
                this.messages.next(Messages.from({ duplicaat: ['involvedDetails.alreadyInvolved'] }));
                return;
            }

            const action = { result: (res: boolean) => { } } as ActionButtonSubmit;
            this.isLoading = true;

            const token = this.auth.token;
            const ticketId = this.currentId;
            if (!ticketId) return;

            const updatedInvolved = new Involved(
                Navigation.NEW,
                ticketId,
                selectedUserId
            );

            this.involvedService
                .createInvolved(token, ticketId, updatedInvolved)
                .subscribe((messages) => {
                    this.updatedInvolved(messages, action, ticketId, token);
                });
        }
    }

    updatedInvolved(messages: Messages, action: ActionButtonSubmit, ticketId: number, token: string) {
        this.isLoading = false;
        this.messages.next(messages);

        if (!messages.hasAnyMessages) {
            this.involvedForm.reset();
            this.involvedService.clearFormStateBackup();

            this.ticketService
                .getTicketWithParts(token, ticketId, this.ticket || undefined)
                .subscribe((resMessages) => {
                    this.messages.next(resMessages);
                });

            const url = `tickets/${ticketId}/fragment/involved/${Navigation.NEW}`;
            this.router.navigate([url]);
        }
    }

    relaySingleChoice(choice: SingleChoice) {
        this.showSaveButton = true;

        const currentId = this.involvedForm.get('involved')?.value;
        window.history.replaceState({ ...window.history.state, tempInvolvedId: currentId }, '');

        choice.waiting.subscribe(() => {
        });

        this.nav.startChoice(choice);
    }

    userIdObserver: Partial<Observer<number>> = {
        next: (value: number) => {
            this.involvedForm.patchValue({ involved: value });
            window.history.replaceState({ ...window.history.state, tempInvolvedId: value }, '');
        },
    };

    get userIdLabelerByService(): Labeler {
        return this.users;
    }

    get TRUE(): boolean { return true; }
    get FALSE(): boolean { return false; }
}